import { ExternalLink } from '@skytech/ui'
import { ImageWithIconFallback } from '@skytech/ui/Image'
import ImageOffOutlineIcon from 'mdi-react/ImageOffOutlineIcon'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { getIsArbitraryBuyoutAvailable, getIsBuyoutAvailable } from '@/ducks/devicePolicyReducer'
import { useLocalDate } from '@/hooks/use-local-date'
import { APP_ROUTES } from '@/util/appRoutes'

import { Translation } from '../i18n/Translation'
// @ts-ignore
const getImage = elm => {
  if (elm.img_url) {
    return elm.img_url
  }

  let model = elm?.device || elm?.asset_description

  if (!model) model = 'iPhoneX'

  return './images/shop_inventory/' + model.replace(/ /g, '') + '.png'
}

const STATUS_TEXT = {
  0: 'Venter på godkjennelse fra leder',
  1: 'Avvist',
  2: 'Til behandling hos leverandør',
  3: 'Ferdig behandlet',
  4: 'Levert',
  5: 'Sendt til leverandør',
}

const OrderStatus = ({ activeOrder, asset }: any) => (
  <div id="order-status" className={activeOrder || asset ? 'is-visible' : 'is-hidden'}>
    <div className="content-wrapper">
      {activeOrder?.model && <ActiveOrder activeOrder={activeOrder} />}

      {!activeOrder && asset && <Asset asset={asset} />}
    </div>
  </div>
)

const ActiveOrder = ({ activeOrder }: any) => {
  const { tracking } = activeOrder

  return (
    <div>
      <div className="header">
        <Translation id="Din bestilling" />
      </div>
      <div>{activeOrder ? activeOrder.model : null}</div>

      <ImageWithIconFallback
        src={getImage(activeOrder || null)}
        alt="product"
        fallbackIcon={<ImageOffOutlineIcon />}
      />

      <div className="status-header">
        <Translation id="Status" />
      </div>
      {/* @ts-ignore */}
      <div>{activeOrder && <Translation id={STATUS_TEXT[activeOrder.status]} />}</div>

      <OrderDateLines order={activeOrder} />

      {tracking && tracking.length > 0 && (
        <div>
          <div className="status-header">
            <Translation id="Tracking" />
          </div>
          {/* @ts-ignore */}
          {tracking.map(id => (
            <div key={id}>
              <ExternalLink
                isWhiteLabeled
                href={`https://sporing.posten.no/sporing/${id}`}
                key={id}
              >
                {id}
              </ExternalLink>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

const OrderDateLines = ({ order }: any) => {
  const { formatDate } = useLocalDate()

  const estimateTextId =
    order && order.status === 3 ? 'Forventet levering' : 'Ny ordre tilgjengelig'
  const estimateDate =
    order &&
    (order.status === 3
      ? formatDate({ date: order.estimated_delivery })
      : formatDate({ date: order.next_order_date }))

  return (
    <div>
      <div className="status-header">
        <Translation id="Sist endret" />
      </div>

      <div>{order ? formatDate({ date: order.order_update }) : null}</div>

      <div className="status-header">
        <Translation id={estimateTextId} />
      </div>

      {estimateDate && <div>{estimateDate}</div>}
    </div>
  )
}

const Asset = ({ asset }: any) => {
  const isBuyoutAvailable = useSelector(getIsBuyoutAvailable)
  const isArbitraryBuyoutAvailable = useSelector(getIsArbitraryBuyoutAvailable)
  const { formatDate } = useLocalDate()

  return (
    <>
      <div className="header">
        <Translation id="Din bestilling" />
      </div>
      <div>{asset.asset_description}</div>

      <ImageWithIconFallback
        src={getImage(asset)}
        alt="product"
        fallbackIcon={<ImageOffOutlineIcon />}
      />

      {!!asset.recieved && (
        <>
          <div className="status-header">
            <Translation id="Levert" />
          </div>
          <div>{formatDate({ date: asset.recieved })}</div>
        </>
      )}

      {asset.next_order_date && (
        <>
          <div className="status-header">
            <Translation id="Ny ordre tilgjengelig" />
          </div>
          <div>{formatDate({ date: asset.next_order_date })}</div>
        </>
      )}

      {isBuyoutAvailable && isArbitraryBuyoutAvailable && (
        <p className="m-0">
          <Link to={APP_ROUTES.buyout} className="buyout">
            <Translation id="Ønsker du å kjøpe ut din telefon?" />
          </Link>
        </p>
      )}

      <p className="m-0">
        <Link to={APP_ROUTES.myAssets} className="buyout">
          <Translation id="Mistet, stjålet eller ødelagt telefon" />
        </Link>
      </p>
    </>
  )
}

export default OrderStatus
